export default "__VITE_ASSET__2ade8665__"